var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"whatsInTheBag"}},[_c('header',{staticClass:"pageHeader rounded"},[_c('fade-image',{staticClass:"darken",attrs:{"src":"assets/headers/profile.png"}})],1),_c('div',{staticClass:"scroller2 green_dark"},[_c('bag-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }